<template>
    <div class="class-list p-b-64 page">
        <div :style="{'padding-top': tabHeight+'px'}">
            <searchComopnent class="list-search-tab" ref="searchTab" :type="type"
                             v-on:onChange="onSearch"></searchComopnent>
            <approveList ref="list" :type="type" :search="search"></approveList>
        </div>
        <van-tabs v-if="$route.query.type == 1"
                  class="list-tab"
                  id="tab1"
                  v-model="approveTabIndex" color="#3388ff">
            <van-tab title="待我审批">
            </van-tab>
            <van-tab title="我已审批">
            </van-tab>
        </van-tabs>
        <van-tabs v-if="$route.query.type == 3 || $route.query.type == 5"
                  class="list-tab"
                  id="tab2"
                  v-model="notifyTabIndex" color="#3388ff">
            <van-tab title="全部">
            </van-tab>
            <van-tab title="未读">
            </van-tab>
        </van-tabs>

    </div>
</template>

<script>
    import head from '../../mixins/head';
    import approveList from './listCompnent';
    import searchComopnent from './listSearchCompnent';
    import { Dialog } from 'vant';

    export default {
        components: {
            approveList,
            searchComopnent
        },
        name: 'approve-list',
        mixins: [head],
        data() {
            return {
                approveTabIndex: 0,
                notifyTabIndex: 1,
                type: '',
                search: {
                    type: '',
                    content: '',
                    status: '',
                    sort: 'DESC'
                },
                time: '',
                tabHeight: 0
            };
        },
        props: {},
        watch: {
            '$route': 'inited',
            'approveTabIndex': function () {
                console.log('approveTabIndex', this.approveTabIndex);
                this.updateType();
            },
            'notifyTabIndex': function () {
                console.log('notifyTabIndex', this.notifyTabIndex);
                this.updateType();
            }
        },
        computed: {},
        created() {
        },
        mounted() {
            console.log('mounted');
            window.refreshList = false;
            window.readAll = () => {
                Dialog.confirm({
                    title: '提示',
                    message: '确认全部标记已读？'
                }).then(() => {
                    // on confirm
                    this.markAllRead();
                }).catch(() => {
                    // on cancel
                });
            };
            this.inited();
        },
        methods: {

            inited() {
                if (this.$route.name == 'approve-list') {
                    if (this.$route.query.type == 1) {
                        this.setTitle('我审批的');
                    } else if (this.$route.query.type == 2) {
                        this.setTitle('我发起的');
                    } else if (this.$route.query.type == 3) {
                        this.setTitle('抄送我的');
                    } else if (this.$route.query.type == 4) {
                        this.setTitle('归档');
                    } else if (this.$route.query.type == 5) {
                        this.setTitle('转发给我');
                    } else if (this.$route.query.type == -1) {
                        this.setTitle('所有流程');
                    }
                    if (this.$route.query.type == 3) {
                        window.moreButton({
                            btnName: '全部已读',
                            action: 'readAll'
                        });
                    } else {
                        window.moreButton({});
                    }
                    if (this.time != this.$route.query.time) {
                        this.time = _.cloneDeep(this.$route.query.time);
                        this.reset();
                    }
                    this.$nextTick(() => {
                        this.initTabHeight();
                    });
                }
            },

            initTabHeight() {
                let tab1 = document.getElementById('tab1');
                if (tab1) {
                    this.tabHeight = tab1.offsetHeight;
                    console.log('tabHeight1', this.tabHeight);
                    return;
                }
                let tab2 = document.getElementById('tab2');
                if (tab2) {
                    this.tabHeight = tab2.offsetHeight;
                    console.log('tabHeight2', this.tabHeight);
                    return;
                }
                this.tabHeight = 0;
                console.log('tabHeight', this.tabHeight);
            },

            reset() {
                this.approveTabIndex = 0;
                this.notifyTabIndex = this.$route.query.unRead ? 1 : 0;
                this.type = '';
                this.updateType();
            },
            // 增加排序 sort
            onSearch(status, types, text, sort) {
                let A = {
                    content: text
                };
                let statusCd = [];
                for (let i = 0; i < status.length; i++) {
                    statusCd.push(status[i].value);
                }
                A.status = statusCd.join(',');
                let ids = [];
                for (let i = 0; i < types.length; i++) {
                    ids.push(types[i].id);
                }
                A.type = ids.join(',');
                if (sort) {
                    A.sort = sort;
                }
                this.search = A;
            },

            updateType() {
                switch (Number(this.$route.query.type)) {
                    case 1:
                        switch (this.approveTabIndex) {
                            case 0:
                                this.type = '1-0';
                                break;
                            case 1:
                                this.type = '1-1';
                                break;
                        }
                        break;
                    case 2:
                        this.type = '2';
                        break;
                    case 3:
                        switch (this.notifyTabIndex) {
                            case 0:
                                this.type = '3-0';
                                break;
                            case 1:
                                this.type = '3-1';
                                break;
                        }
                        break;
                    case 4:
                        this.type = '4';
                        break;
                    case 5:
                        switch (this.notifyTabIndex) {
                            case 0:
                                this.type = '5-0';
                                break;
                            case 1:
                                this.type = '5-1';
                                break;
                        }
                        break;
                    case -1:
                        this.type = '-1';
                        break;
                }
                console.log('updateType', this.type);
            },

            markAllRead() {
                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });
                let param = {};
                this.$http.post('badu/eaa/notifyNotifyMeAllApproveIsRead.do', param, { toast: true })
                    .then(() => {
                        this.$toast.clear();
                        this.$refs['list'].refresh();
                        this.$toast.fail({
                            duration: 1000,
                            forbidClick: true,
                            message: '全部标记已读成功'
                        });
                    })
                    .catch(() => {
                        this.$toast.fail({
                            duration: 1000,
                            forbidClick: true,
                            message: '全部标记已读失败'
                        });
                    });
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/approve-list.scss';

    .list-tab {
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
    }

    .list-search-tab {
        /*position: absolute;*/
        /*top: 0;*/
        /*right: 0;*/
        /*left: 0;*/
        width: 100%;
    }
</style>
